export default __webpack_public_path__ + "static/media/Loan-cart-Icon.5fd06905.svg";